<template>
  <div class="top-hat-container">
    <NovaNavBuilder
      v-if="topHatData.navSections"
      nav-type="top-drawer"
      mobile-nav-type="item-list"
      theme="dark"
      :content="topHatData">
    </NovaNavBuilder>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { NovaNavBuilder } from '@nova/ui';

export default {
  components: { NovaNavBuilder },
  computed: {
    ...mapState({
      topHatData: (state) => state.tophat.topHatData,
    }),
  },
  mounted() {
     this.getTopHatData();
  },
  methods: {
    ...mapActions({
      getTopHatData: "tophat/getTopHatData",
    }),
  },
};
</script>

<style scoped lang="scss">
.top-hat-container {
  ::v-deep {
    .nav-mobile-content {
      z-index: $mds-z-index-sticky;
    }
  }
}
</style>
